// tslint:disable:max-line-length

import React from 'react';

export const EditorItalics = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M4.8,13L9,0h2.2L7,13H4.8z" />
      <path d="M5.7,2l0.5-2h7.2l-0.5,2H5.7z" />
      <path d="M2.7,13l0.5-2h7.2l-0.5,2H2.7z" />
    </svg>
  );
};
